export default __webpack_public_path__ + "static/media/hy.7bfa795f.jpg";